import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Stack
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

const FilterListSection = ({ title, filters, onDelete, color = 'primary' }) => {
  const getChipLabel = (filter) => {
    const filter_type = filter.filter;
    const field = filter.field ;
    let label = null ;
    if (filter_type === 'term') {
      label = field+': '+filter.value;
    } else if (filter_type === 'terms') {
      label = field+': '+filter.value.join(', ');
    } else if (filter_type === 'numeric') {
      label = `${field} ${filter.operator} ${filter.value}`;
    } else if (['is_null', 'not_null'].includes(filter_type)) {
      label = field+': '+filter_type;
    } else if (filter_type === 'custom') {
      label = '{custom json}';
    } else if (filter_type === 'match') {
      label =  `match(${field}): `+filter.value.join(', ');
    } else if (filter_type === 'geo') {
      label = `${field}: `+filter.value.join(', ');
    } else if (filter_type === 'date') {
      if (filter.value.date_from && filter.value.date_to) {
        label = `${field} from ${filter.value.date_from} to ${filter.value.date_to}`;
      } else if (filter.value.date_from && !filter.value.date_to) {
        label = `${field} after ${filter.value.date_from}`;
      } else if (!filter.value.date_from && filter.value.date_to) {
        label = `${field} before ${filter.value.date_to}`;
      }
    } else if (filter_type === 'group_boost') {
      label = `group_boost(${filter.value}, ${filter.group}, ${field})`;
    } else if (filter_type === 'terms_lookup') {
      label = `${filter.value} -> ${filter.path} -> ${field}`;
    } else if (filter_type === 'console_account') {
      label = `${filter.value.substring(0, 8)} -> ${filter.path} -> ${field}`;
    } else {
      label = filter_type
    } 

    if (field==='channels') {
      const channels = filter.value.map(channel => {return channel.split('/').pop()});
      label = field+': '+channels.join(', ');
    }
    
    if (filter.boost && filter.boost > 0) {
      label += ` [${filter.boost.toFixed(1)}]^`;
    }
    return label;
  };

  if (filters.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: color === 'primary' ? 2 : 0 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {title}:
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {filters.map((filter, index) => (
          <Chip
            key={index}
            label={getChipLabel(filter)}
            onDelete={() => onDelete(index)}
            deleteIcon={<DeleteIcon />}
            color={color}
            variant="outlined"
          />
        ))}
      </Stack>
    </Box>
  );
};

export default FilterListSection;
